import memoizeWithIdentity from "ramda-extension/es/memoizeWithIdentity";
import { dropdownCloseEventName } from '../constants';
const createNewEvent = memoizeWithIdentity((eventName)=>{
    let event;
    if (typeof Event === 'function') {
        event = new Event(eventName);
    } else {
        event = document.createEvent('Event');
        event.initEvent(eventName, true, true);
    }
    return event;
});
export const createDropdownCloseEvent = ()=>createNewEvent(dropdownCloseEventName);
